export default __webpack_public_path__ + "static/media/box-qmenta-platform.66dd844e.svg";